import React from 'react';
// import { render } from 'react-dom';
import { createRoot } from 'react-dom/client';
import App from './App';
import './style/css/inter.css';
import './style/css/main.css';
import './i18n/i18n';
import i18n from './i18n/i18n';

const searchParams = new URLSearchParams(window.location.search);

function Main() {
  let token = process.env.REACT_APP_TOKEN || '';
  const partner = searchParams.get('partner') || '';
  const staged = process.env.REACT_APP_STAGED === 'true';
  const lang = process.env.REACT_APP_LANG || 'ru';
  const email = process.env.REACT_APP_EMAIL || '';

  i18n.changeLanguage(lang);
  const getToken = searchParams.get('app-token') || '';
  if (process.env.NODE_ENV === 'development' && !!getToken) {
      token = getToken;
    }

    console.log('******* DROP CONSOLE.LOG not working');

    return (
      <>
          <App token={token} partner={partner} staged={staged} email={email} />
      </>
    );
}

const rootElement = createRoot(document.querySelector('#root')!)
rootElement.render(<Main />);
